module.exports = __webpack_public_path__ + "static/media/ivanaTim.fb1e60f6.jpg";